<template>
	<div class="insideBody">
		<div class="studyReport">
			
			<div class="main" id="capture">
				
				<div class="conTop on clr">
					<div class="export fr" @click="getImg">导出学习报告</div>
				</div>
				
				<div class="data_top">
					<ul>
						<li class="li1">
							<div class="tit">总学习时长</div>
							<div class="text"><span>{{reportdata.xxsc}}</span>分钟</div>
						</li>
						<li class="li2">
							<div class="tit">学习单词数量</div>
							<div class="text"><span>{{reportdata.xxdc}}</span>个</div>
						</li>
						<li class="li3">
							<div class="tit">消灭生词</div>
							<div class="text"><span>{{reportdata.xmsc}}</span>个</div>
						</li>
					</ul>
				</div>
				
				<div class="data_list">
					<div class="tits">
						生词消灭统计
					</div>
					<div class="Chart clr">
						<div id="Chart" class="fl Chartjc"></div>
						<div class="ChartjcDate fl">
							<div class="list">
								<div class="tit">{{reportdata.sczs}}</div>
								<div class="name">生词总数（个）</div>
							</div>
							<div class="list">
								<div class="tit">{{reportdata.yxm}}</div>
								<div class="name"><i class="yxm"></i>已消灭（个）</div>
							</div>
							<div class="list">
								<div class="tit">{{reportdata.wxm}}</div>
								<div class="name"><i class="mxm"></i>未消灭（个）</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="details hide"> <!-- 详情 -->
				<div class="data_list">
					<div class="tits">
						学习详情
					</div>
					<div class="table">
						<el-table
							:height="200"
							:data="tableData"
							style="width: 100%">
							<el-table-column
								align="center"
								prop="date1"
								min-width="120"
								label="时间">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date2"
								min-width="100"
								label="学习类型">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date3"
								min-width="120"
								label="教材版本">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date4"
								min-width="100"
								label="单元/难度">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date5"
								min-width="100"
								label="学习时长">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date6"
								min-width="100"
								label="有效时长">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date7"
								min-width="150"
								label="掌握单词/成绩">
								<template slot-scope="scope">
									{{scope.row.date7}}
									<span class="btn" @click="checkwrongBlon = true">查看</span>
									<span class="btn">导出</span>
								</template>>
							</el-table-column>
							<el-table-column
								align="center"
								prop="date8"
								min-width="80"
								label="积分">
								<template slot-scope="scope">
									<span class="red">{{scope.row.date8}}</span>
								</template>>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :total="100">
					</el-pagination>
				</div>
			</div>
			
			<div class="Checkwrong hide" :class="checkwrongBlon?'on':''"> <!-- 查看错题弹窗 -->
				<div class="Checkcont">
					<div class="tits">查看错题<div class="btnGb" @click="checkwrongBlon = false"></div></div>
					<div class="cont" :style="{height: height+'px'}">
						<div class="titc">学前学后测 - 分段 - 人教版初中七年级下册(简单)</div>
						<div class="contct">
							<div class="list">
								<div class="tit">1. <span>post</span></div>
								<ul>
									<li class="yes">n.关键；要诀</li>
									<li class="wrong">n.家庭（包括父母和子女）；家族</li>
									<li>n.邮政</li>
									<li>n.木偶</li>
								</ul>
							</div>
							<div class="list">
								<div class="tit">2. <span>post</span></div>
								<ul>
									<li class="yes">n.关键；要诀</li>
									<li>n.家庭（包括父母和子女）；家族</li>
									<li class="wrong">n.邮政</li>
									<li>n.木偶</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="btn_list">
						<div class="btn" @click="checkwrongBlon = false">关 闭</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>
<script>

import domtoimage from 'dom-to-image';
import { getjcbzy } from "../../api/report";

export default {
  data(){
    return {
      userinfo: this.utils.storageGet("userinfo"),
			height: null,
      checkwrongBlon: false,
      reportdata:{
        xxsc:0,
        xxdc:0,
        xmsc:0,
        sczs:0,
        wxm:0,
        yxm:0
      },
			tableData: [{
				date1: '06-26 14:00',
				date2: '单词突击',
				date3: '人教版七年级上册',
				date4: 'UNIT3',
				date5: '17分46秒',
				date6: '15分20秒',
				date7: '20/40',
				date8: '+15',
			}, {
				date1: '06-26 14:00',
				date2: '单词突击',
				date3: '人教版七年级上册',
				date4: 'UNIT3',
				date5: '17分46秒',
				date6: '15分20秒',
				date7: '20/40',
				date8: '+15',
			}]
		};
	},
	created(){
    let that = this;
    getjcbzy({userid:that.userinfo.userid}).then(res=>{
      that.reportdata.xxsc = res.xxsc;
      that.reportdata.xxdc = res.xxdc;
      that.reportdata.xmsc = res.xmsc;
      that.reportdata.sczs = res.sczs;
      that.reportdata.wxm = res.wxm;
      that.reportdata.yxm = res.yxm;

      that.Chart();
    });
	},
	methods:{
    getImg() {

      let node = document.getElementById('capture');
      domtoimage.bgcolor = '#ffffff';
     
      domtoimage.toPng(node).then(
        (dataUrl) => {
          let userinfo = this.utils.storageGet("userinfo");
       
          let link = document.createElement("a");
          link.href = dataUrl;//下载链接
          link.setAttribute("download",`${userinfo.username} - 教材版.png`);
          link.style.display = "none";//a标签隐藏
          document.body.appendChild(link);
          link.click();
        }        
      ).catch(function (error) {
        console.error('oops, something went wrong!', error);
      });

     
    },
		Chart(){
			var that = this,myChart = that.$echarts.init(document.getElementById('Chart'));
			myChart.clear();
			// 绘制图表
			myChart.setOption({
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				label: {
					show: true,
					position: 'outside',
					formatter: '{d}%',
				},
				series: [
					{
						name: '生词',
						type: 'pie',
						radius: ['50%', '70%'],
						color: ['#ff7859', '#598cff'],
						data: [
							{value: that.reportdata.yxm,name:'已消灭（个）'},
							{value: that.reportdata.wxm,name:'未消灭（个）'},
						],
					}
				]
			});
		}
	},
	mounted(){
		var that = this;
		that.height = window.innerHeight - (450*that.utils.per());
		
	}
}
</script>
<style scoped>
	
</style>